import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=0f56c0ab&scoped=true&"
import script from "./AddTemplate.vue?vue&type=script&lang=js&"
export * from "./AddTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56c0ab",
  null
  
)

export default component.exports